import { IsDefined, IsString, IsNotEmpty } from 'class-validator';

export class Address {
    @IsString()
    @IsDefined()
    public address: string;

    @IsString()
    @IsDefined()
    @IsNotEmpty()
    public latitude: string;

    @IsString()
    @IsDefined()
    @IsNotEmpty()
    public longitude: string;

    constructor(data?: Partial<Address>) {
        this.address = data?.address;
        this.latitude = data?.latitude;
        this.longitude = data?.longitude;
    }

    public getCoordsString(): string {
        return `${this.latitude},${this.longitude}`;
    }

    public static from(value: string): Address {
        let parsedData: Partial<Address>;
        try {
            parsedData = JSON.parse(value) as Address;
        } catch {
            return undefined;
        }

        if (!parsedData) {
            return undefined;
        }

        if (!parsedData.address || !parsedData.latitude || !parsedData.longitude) {
            throw new Error(`Expected Address entity with filled fields, got: ${value}`);
        }

        return new Address(parsedData);
    }
}
